export default __webpack_public_path__ + "ee6f83dea1daf82bde272f266082d435.svg";